import { Injectable } from '@angular/core';
import { HttpClient } from '../shared/http-client';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'

import { ListadoEnvios } from '../models/viewmodels/listadoEnvios';
import { EnvioViewModel } from '../models/viewmodels/envioViewModel';
import { ReenvioComprobanteViewModel } from '../models/viewmodels/ReenvioComprobanteViewModel';


@Injectable()
export class EnvioService {

    private envioActual: EnvioViewModel;

    constructor(private httpClient: HttpClient) { }

    setEnvio(envio: EnvioViewModel) {
        this.envioActual = envio;
    }

    getEnvio() {
        return this.envioActual;
    }

    listado(pagina: number, cantidadPorPagina: number, query: string): Observable<ListadoEnvios> {
        // get users from api
        return this.httpClient.get(`/envios/?pagina=${pagina}&cantidadPorPagina=${cantidadPorPagina}&query=${query}`)
            .map(response => {
                return response.json();
            });
    }

    eliminar(id: number) {
        return this.httpClient.delete(`/envios/${id}`);
    }

    reenviar(id: number) {
        return this.httpClient.post(`/envios/${id}/reenviar`, null);
    }

    reenviarComprobantes(reenvioComprobantes: ReenvioComprobanteViewModel) {
        return this.httpClient.post(`/envios/reenviar`, reenvioComprobantes);
    }
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/services/envio.service.ts